import React from "react";

const MoonTimeline = ({ moonrise, moonset, moonPhase }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getNightProgress = () => {
    const now = new Date().getTime() / 1000;
    const nightStart = moonrise;
    const nightEnd = moonset;
    const nightLength = nightEnd - nightStart;
    const currentProgress = (now - nightStart) / nightLength;
    return Math.max(0, Math.min(1, currentProgress)) * 100;
  };

  const getMoonPosition = () => {
    const progress = getNightProgress();
    if (progress <= 0) return "Daytime";
    if (progress >= 100) return "Daytime";
    if (progress < 25) return "Rising";
    if (progress < 75) return "High";
    return "Setting";
  };

  const moonPosition = getMoonPosition();
  const nightProgress = getNightProgress();

  return (
    <div>
      <div className="relative h-32 mb-4">
        {/* Sky gradient background */}
        <div className="absolute inset-0 rounded-lg overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-gray-800 via-gray-600 to-blue-300" />
        </div>

        {/* Moon position indicator */}
        <div
          className="absolute top-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow-lg"
          style={{
            left: `${nightProgress}%`,
            transform: `translate(-50%, -50%)`,
          }}
        />

        {/* Timeline markers */}
        <div className="absolute bottom-0 left-0 right-0 flex justify-between px-2">
          <div className="text-white text-sm">{formatTime(moonrise)}</div>
          <div className="text-white text-sm">{formatTime(moonset)}</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-sm text-gray-600">Moonrise</div>
          <div className="font-medium">{formatTime(moonrise)}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Current</div>
          <div className="font-medium">{moonPosition}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Moonset</div>
          <div className="font-medium">{formatTime(moonset)}</div>
        </div>
      </div>

      <div className="mt-4 text-sm text-gray-600">
        {moonPosition === "Daytime" && "The moon is below the horizon."}
        {moonPosition === "Rising" && "The moon is rising in the sky."}
        {moonPosition === "High" && "The moon is high in the sky."}
        {moonPosition === "Setting" && "The moon is setting in the sky."}
      </div>

      <div className="mt-2 text-sm text-gray-600">
        Current Moon Phase: {moonPhase}
      </div>
    </div>
  );
};

export default MoonTimeline;
